import React, { Component } from "react";
import "./style.css";
class AboutUs extends Component {
  render() {
    return (
      <div className="about_us_box">
        <div className="about_us_win_box">
          <img
            alt=""
            className="about_us_win_img_box"
            src={require("../../../../../../images/fastSearch/about_window.png")}
          ></img>
          <img
            alt=""
            onClick={() => this.props.handleShowOrClose()}
            className="about_us_close_img_box"
            src={require("../../../../../../images/fastSearch/close.png")}
          ></img>
        </div>
      </div>
    );
  }
}

export default AboutUs;



// WEBPACK FOOTER //
// ./src/containers/Home/components/FastSearch/components/AboutUs/index.js